import classNames from 'classnames';
import styles from './SvgIcon.module.scss';

interface SvgIconProps {
	src: string;
	className?: string;
	style?: any;
	onClick?: () => void;
}

const SvgIcon = ({ src, className, style, onClick }: SvgIconProps) => (
	<div className={classNames(styles.imgContainer, className)} style={style} onClick={onClick}>
		<img src={src} />
	</div>
);

export default SvgIcon;
